var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVolumeFull = function SvgVolumeFull(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 6C18 6 21 8 21 12C21 16 18 18 18 18",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 8 18 9.5 18 12C18 14.5 16 16 16 16",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11.0292C3 10.0699 3 9.59023 3.16115 9.21347C3.3635 8.74039 3.74039 8.3635 4.21347 8.16115C4.59023 8 5.0699 8 6.02924 8C6.35575 8 6.51901 8 6.67691 7.97458C6.87544 7.94263 7.06801 7.88091 7.24814 7.79152C7.3914 7.72043 7.52425 7.62554 7.78994 7.43575L10.8375 5.25891C12.2226 4.26956 12.9152 3.77488 13.4576 4.05402C14 4.33316 14 5.18423 14 6.88638V17.1136C14 18.8158 14 19.6668 13.4576 19.946C12.9152 20.2251 12.2226 19.7304 10.8375 18.7411L7.78994 16.5642C7.52425 16.3745 7.3914 16.2796 7.24814 16.2085C7.06801 16.1191 6.87544 16.0574 6.67691 16.0254C6.51901 16 6.35575 16 6.02924 16C5.0699 16 4.59023 16 4.21347 15.8389C3.74039 15.6365 3.3635 15.2596 3.16115 14.7865C3 14.4098 3 13.9301 3 12.9708V11.0292Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVolumeFull);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "volume-full.bcd132f7f152239be90323991ca3832b.svg";